import { SET_PROBLEM_LIST } from './actionType'

export function setProblemList(problems) {
  return {
    type: SET_PROBLEM_LIST,
    problems: problems,
  }
}
